import React from 'react';

import classes from './PsmPage.module.css';
import PageTitle from '../../UI/PageTitle';
import { BasicContainer } from '../../UI/ContentContainer';
import TextContent from '../../UI/TextContent';
import { Box, Hidden, Typography } from '@mui/material';
import Material from './Material';
import { UlList } from '../../UI/List/List';

// image
import process_pc from '../../../assets/img/psm_page/process_pc.png';
import process_mb from '../../../assets/img/psm_page/process_mb.png';



import Grid from '@mui/material/Unstable_Grid2/Grid2';
import Calendar from '../ImageComponent/Calendar';
import SmoFoldList from '../SmoPage/SmoFoldList';
import MetaTags from '../../MetaTags/MetaTags';

const target = [
    '원유정제 업체',
    '달리 분류되지 아니한 석유정제 분해물 재 처리업',
    '석유 화학계 기초 유기화합물 제조업 및 합성수지제조업',
    '질소질 비료 제조업',
    '농약 제조업',
    '화학 및 불꽃 제조업',
    '금속가공제품 제조업',
    '위 사업장외의 경우에는 유해 위험물질의 하나 이상을 아래표1에 의한 규정량 이상 제조, 취급, 사용, 저장하는 설비 및 당해 설비의 운영에 관련된 일체의 공정설비 및 위의 사항에 적용되는 설비',
];

const ulList = [
    {
        title: '유해 위험설비의 설치 이전 또는 주요구조 부분의 변경 공사 착공일 30일 전까지',
        sub: [
            '산업안전보건위원회 심의 또는 근로자대표 의견 반영',
            '증설 변경으로 보고서를 제출하는 경우에는 기존 심사 받은 내용과 동일한 내용은 제출을 면제'
        ]
    },
    {
        title: '이행상태 평가결과 불량 사업장은 다시 제출',
        sub: false
    },
    {
        title: '변경사유 발생 시 보고서 내용 지체없이 보완',
        sub: [
            '주요 구조부분 변경 이외의 변경인 경우'
        ]
    }
];

const raw = [
    {
        id: 1,
        title: <div><p>공정안전보고서를 작성하여 제출하지 않은 경우</p></div>,
        subtitle: '제재사항',
        tableHead: ['근거 법조문', '1차', '2차', '3차'],
        data: [
            ['법 제72조 제3항 제2호', 300, 600, Number(1000).toLocaleString()]
        ]
    },
    {
        id: 2,
        title: <div><p>산업안전보고위원회의 심의를 거치지 않거나 근로자 대표의 의견을 듣지 않은 경우</p></div>,
        subtitle: '제재사항',
        tableHead: ['근거 법조문', '1차', '2차', '3차'],
        data: [
            ['법 제72조 제4항 제3호', 50, 250, 500]
        ]
    },
    {
        id: 3,
        title: <div><p>공정안전보고서를 사업장에 갖춰 두지 않은 경우</p></div>,
        subtitle: '제재사항',
        tableHead: ['근거 법조문', '1차', '2차', '3차'],
        data: [
            ['법 제72조 제3항 제2호', 100, 250, 500]
        ]
    },
    {
        id: 4,
        title: <div><p>고용노동부 장관의 확인을 받지 않은 경우</p></div>,
        subtitle: '제재사항',
        tableHead: ['근거 법조문', '1차', '2차', '3차'],
        data: [
            ['법 제72조 제5항 제11호', 30, 150, 300]
        ]
    },
    {
        id: 5,
        title: <div><p>공정안전보고서의 내용을 지키지 않은 경우</p></div>,
        subtitle: '제재사항',
        tableHead: ['근거 법조문', '세부사항', '1차', '2차', '3차'],
        data: [
            ['법 제72조 제3항 제2호', '사업주 (내용위반 1건당)', 5, 20, 30],
            ['법 제72조 제3항 제2호', '근로자 (내용위반 1건당)', 5, 10, 15]
        ]
    },

];





const PsmPage = () => {
    return (
        <BasicContainer>
            <MetaTags
                title="공정안전보고서(PSM)"
                description="공정안전보고서(PSM)에 대해 소개 합니다."
                ogtitle="드림산업안전센터(주)-공정안전보고서(PSM)"
                ogdescription="공정안전보고서(PSM)에 대해 소개 합니다."
            />
            <PageTitle title="공정안전보고서(PSM)"/>
            <TextContent title="공정안전보고서(PSM)" data-aos="fade-up">
                <Typography variant="description" component="p" sx={{lineHeight: "2"}}>
                    산업안전보건법 제49조의2 공정안전보고서의 제출 등에 따라 유해·위험물질을 제조·취급·저장 하는 설비를 보유한 사업장은 그 설비로부터 유해·위험물질 누출 및 화재·폭발 등으로 인한 '중대산업사고'를 예방하기 위하여 공정안전보고서를 작성·제출하는 제도
                </Typography>
            </TextContent>

            <TextContent title="구성 요소" data-aos="fade-up">
                <Typography variant="description" component="p" sx={{lineHeight: "2"}}>
                    중대산업사고 발생 위험이 큰 유해 위험 설비를 보유한 사업장에 대하여 산업안전보건법 제49조의2에 의거 공정안전자료, 공정 위험성평가, 안전운전계획 및 비상조치계획 수립 등에 관해 보고서를 작성 심사 및 확인을 통해 중대 산업사고를 예방
                </Typography>
            </TextContent>

            <TextContent title="제출 대상 업종" data-aos="fade-up">
                <Typography variant="description" component="p" sx={{lineHeight: "2"}}>
                    중대산업사고 발생 위험이 큰 유해 위험 설비를 보유한 사업장에 대하여 산업안전보건법 제49조의2에 의거 공정안전자료, 공정 위험성평가, 안전운전계획 및 비상조치계획 수립 등에 관해 보고서를 작성 심사 및 확인을 통해 중대 산업사고를 예방
                </Typography>
                <Box marginTop="2rem">
                    <table className={classes.table}>
                        <thead>
                            <tr>
                                <th><Typography variant="contentTitleSmall" component="p">NO</Typography></th>
                                <th><Typography variant="contentTitleSmall" component="p">대상업종</Typography></th>
                            </tr>
                        </thead>
                        <tbody>
                            {target.map((item, index) => (
                                <tr key={index}>
                                    <td><Typography variant="contentTitleSmall" component="p" textAlign="center">{index+1}</Typography></td>
                                    <td><Typography variant="contentTitleSmall" component="p" textAlign="left">{item}</Typography></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
                
            </TextContent>

            <TextContent title="공정안전보고서 제출 대상 물질 51종" data-aos="fade-up">
                <Material 
                    caption="공전안전보고서 제출 대상 물질 21종"
                    division="basic"
                />

                <Material 
                    caption="공정안전보고서 제출 대상물질 30종 (신규확대 물질)"
                    division="extend"
                />
            </TextContent>

            <TextContent sectionStyle={{backgroundColor: '#F8F9FA'}}>
                <Grid container justifyContent='center' spacing={2}>
                    <Grid sm={12} md={4} display="flex" justifyContent="center" alignItems="center">
                        <Calendar style={{width: '10rem'}} data-aos="fade-right"/>
                    </Grid>
                    <Grid sm={12} md={8}>
                        <div data-aos="fade-left"> 
                            <Typography variant="subTitle" marginBottom="1rem" component="h4">제출 시기</Typography>
                            <UlList data={ulList} />
                        </div>
                    </Grid>
                </Grid>
            </TextContent>

            <TextContent title="컨설팅 절차" data-aos="fade-up">
                    <Box textAlign="center" paddingTop="5rem">
                        <Hidden smDown>
                            <img src={process_pc} alt="process_pc" style={{maxWidth: '1008px', width:'100%'}}/>
                        </Hidden>
                        <Hidden smUp>
                                <img src={process_mb} alt="process_mb" style={{maxWidth: '514px', width:'100%'}}/>
                        </Hidden>
                    </Box>

            </TextContent>

            <TextContent title="법적제재사항" data-aos="fade-up">
                <Box display="flex" gap={2} flexDirection="column">
                    {
                        raw.map(data => (
                            <SmoFoldList 
                                key={data.id}
                                titleSx={{whiteSpace: 'pre-line'}}
                                title={data.title}
                                subtitle={data.subtitle}
                                thead={data.tableHead}
                                data={data.data}
                            />
                        ))
                    }
                </Box>
            </TextContent>

        </BasicContainer>
    )
}

export default PsmPage;